<template>
  <div class="module-wrapper">
    <div class="module-header animated fadeInDown">
      <h2>Units</h2>
      <button @click="goToAddUnit" class="btn btn-gradient">
        <i class="fas fa-plus"></i> Add Unit
      </button>
    </div>

    <div v-if="loading" class="spinner-container">
      <i class="fas fa-spinner fa-spin fa-2x"></i> Loading Units...
    </div>

    <div v-else>
      <table v-if="units.length" class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Name</th>
            <th>Status</th>
            <th>Workers</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="unit in units" :key="unit.id">
            <td>{{ unit.name }}</td>
            <td>
              <span class="badge" :class="unit.status === 'active' ? 'active' : 'inactive'">
                {{ unit.status }}
              </span>
            </td>
            <td>{{ unit.workersCount }}</td>
            <td>
              <button @click="editUnit(unit)" class="btn btn-sm btn-primary">Edit</button>
              <button @click="deleteUnit(unit.id)" class="btn btn-sm btn-danger">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>

      <p v-else>No units available. Click "Add Unit" to create one.</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'UnitsComponent',
  computed: {
    ...mapState('units', ['units', 'loading']),
  },
  methods: {
    goToAddUnit() {
      this.$router.push({ name: 'AddUnit' });
    },
    editUnit(unit) {
      console.log('Edit', unit);
      // open modal or redirect to edit page
    },
    deleteUnit(id) {
      if(confirm('Are you sure you want to delete this unit?')) {
        this.$store.dispatch('units/deleteUnit', id);
      }
    }
  },
  mounted() {
    this.$store.dispatch('units/fetchUnits');
  }
}
</script>

<style scoped>
.module-wrapper {
  padding: 20px;
  background: #f4f6f9;
  border-radius: 12px;
}
.module-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.btn-gradient {
  background: linear-gradient(135deg, #7b2cbf, #9d4edd);
  color: #fff;
  border: none;
  padding: 8px 15px;
  border-radius: 6px;
  transition: all 0.3s ease;
}
.btn-gradient:hover {
  transform: scale(1.05);
}
.badge.active { background-color: #28a745; }
.badge.inactive { background-color: #dc3545; }
.spinner-container {
  display:flex; justify-content:center; align-items:center; height:100px; font-size:1.2rem; color:#555;
}
</style>
